import "p2";
import "pixi";
import "phaser";

import { GameConstants } from "./GameConstants";
import { Game } from "./Game";
import { GameVars } from "./GameVars";

window.onload = () => {

    const game = new Game();

    if (GameConstants.SPONSOR === GameConstants.SPONSOR_GAMEPIX) {

        GamePix.on.pause = function (): void {
            game.paused = true;
        };

        GamePix.on.resume = function (): void {
            game.paused = false;
        };

        GamePix.on.soundOn = function (): void {
            if (!GameVars.gameData.muted) {
                game.sound.mute = false;
            }
        };

        GamePix.on.soundOff = function (): void {
            game.sound.mute = true;
        };
    }
};
